






import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class WelcomeView extends Vue {}
